<template>
  <div class="footer">
    <a-layout-footer style="background: transparent; padding-left: 0; color: #9A999A; text-align: center;" v-if="winStatus">
      Copyright © 2025 ARTECHNOLOGY。 All Right Reserved.
    </a-layout-footer>

    <div class="footer-h5" v-else>
      <div class="inner flex">
        <div class="flex-1 item" v-for="(item, index) in list" :key="index" @click="$router.push(item.path)">
          <template v-if="index != 2">
            <a-icon :type="item.icon" :style="{ 'color': $route.path == item.path ? '#FFFF00' : '#fff', 'fontSize': '20px' }" />
            <div>{{ item.label }}</div>
          </template>
          <template v-else>
            <img src="@/assets/center.png" alt="">
            <div>{{ $t('portfolio.配套') }}</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { label: this.$t('Common.DASHBOARD'), icon: 'home', path: '/home'  }, 
        { label: this.$t('Common.WALLET'), icon: 'wallet', path: '/wallet'  }, 
        {  path: '/portfolio'  }, 
        { label: this.$t('Common.REFERRAL PROGRAM'), icon: 'usergroup-add', path: '/invite'  }, 
        { label: this.$t('userLogin.My Profile'), icon: 'user', path: '/profile/xs' }, 
      ],
      winStatus: window.innerWidth > 768
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
a {
  color: #252F4A;
}


@media screen and (max-width: 576px) {
  .footer-h5 {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99999;
    width: 100vw;
    padding: 7px 0;
    border-top: 1px solid #454549;
    background-color: #111015;

    border-radius: 20px 20px 0 0;

    .inner {
      width: 100%;
      padding: 10px 0 15px;
    }
    .item {
      text-align: center;
      cursor: pointer;
      div {
        margin-top: 5px;
        font-size: 11px;
        color: #fff;
      }
    }

    img {
      margin-top: -40px;
      width: 60px;
      height: 60px;
    }
  }
}
</style>